import { generateClassName } from '@klv/shared/utils/functions';
import KlaviyoFormAtom from '@klv/atoms/klaviyo-form';
import Button from '@klv/atoms/button';
import Eyebrow from '@klv/atoms/eyebrow';
import Icon from '@klv/atoms/icon';

import * as styles from './styles/more-card.module.css';

import type { TIconName } from '@klv/atoms/icon/types';
import type { IMoreCard } from './types';

const MoreCard = ({
  eyebrow,
  icon,
  richText = '',
  formId = '',
  button,
  className,
  ...props
}: IMoreCard) => (
  <div
    className={generateClassName([styles.moreCard, formId !== '' ? styles.hasForm : '', className])}
    {...props}
  >
    {button && button.url && (
      <a
        className={styles.moreLink}
        aria-label={button.openInNewTab ? `${eyebrow} (opens in a new tab)` : ''}
        href={button.url}
        target={button.openInNewTab ? '_blank' : '_self'}
      />
    )}
    <div className={styles.innerCard}>
      <div className={styles.contentContainer}>
        <Eyebrow className={styles.eyebrow} content={eyebrow} />
        <Icon className={styles.icon} color="currentColor" iconName={icon.iconName as TIconName} size={3.2} />
        {formId && <KlaviyoFormAtom formId={formId} />}
        {richText && (
          <div
            className={styles.bodyText}
            dangerouslySetInnerHTML={{ __html: richText }}
          />
        )}
      </div>
      {button && (
        <div className={styles.buttonContainer}>
          <Button
            className={styles.button}
            url={button.url}
            variant="tertiary"
            text={button.text}
            buttonColor="dark"
            openInNewTab={button.openInNewTab}
          />
        </div>
      )}
    </div>
  </div>
);

export default MoreCard;
